/*
 * @Descripttion:
 * @Author: voanit
 * @Date: 2021-01-11 11:08:40
 * @LastEditors: sjq
 * @LastEditTime: 2022-07-22 10:23:50
 */
import store from '@/store'
//根据code显示名称
export const filter = function (value, array, type) {
  let values = 'value',
    label = 'label'
  if (type === 'dict') {
    values = 'dictValue'
    label = 'dictName'
  }
  for (let i = 0; i < array.length; i++) {
    if (array[i][values] === value) {
      return array[i][label]
    }
  }
}
//表格翻页置顶
export function scrollTop0(itme) {
  itme.$refs.table.$refs.bodyWrapper.scrollTop = 0
}

export const formatDate = function (date, key, index) {
  let newDate
  switch (key) {
    case 'mounth':
      newDate = date.getMonth() > 9 ? date.getMonth() : `0${date.getMonth() + 1}`
      break
    case 'day':
      newDate = date.getDate() > 9 ? date.getDate() : `0${date.getDate()}`
      break
    case 'hours':
      newDate = date.getHours() > 9 ? date.getHours() : `0${date.getHours()}`
      break
    case 'min':
      newDate = date.getMinutes() > 9 ? date.getMinutes() : `0${date.getMinutes()}`
      break
    default:
      newDate = ''
  }
  return newDate
}

/***
 * 校验用户有没有某个按钮点击权限
 * */
export const hasCodeRight = permissionRoles => {
  const codeAll = store.getters.token
  return codeAll?.some(code => permissionRoles == code)
}

export function validatorMobile(rule, value, callback) {
  if (value && !/^1\d{10}$/.test(value)) {
    callback(new Error('请输入正确的手机号码'))
  } else {
    callback()
  }
}
export function validatorPassword(rule, value, callback) {
  if (value && !/^(?=.*[0-9])(?=.*[a-zA-Z])[0-9A-Za-z!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?`~]{6,}$/.test(value)) {
    callback(new Error('长度不少于8位，且包含数字、字母和特殊字符'))
  } else {
    callback()
  }
}
